import { useTranslation } from 'react-i18next';

interface PreviewLangSwitcherProps {
  langs: readonly string[];
  activeLang: string;
  setPreviewLang: (lang: string) => void;
}

export function PreviewLangSwitcher({ langs, activeLang, setPreviewLang }: PreviewLangSwitcherProps) {
  const { t } = useTranslation();

  return (
    <div className="pvx-lang-switcher">
      <span className="pvx-lang-label"><i className="fas fa-eye" /> {t('admin.builderPreviewViewIn')}</span>
      {langs.map(l => (
        <button
          key={l}
          type="button"
          className={`pvx-lang-btn${activeLang === l ? ' active' : ''}`}
          onClick={() => setPreviewLang(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
